















































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import { getMonthName } from "@/utils/date-helpers";
import { roles } from "@/config/roles";


/**
 * Components
 */
import CreateCompositionGroupDialog from "./components/CreateCompositionGroupDialog.vue";
import CalendarDayList from "./components/CalendarDayList.vue";
import Calendar, { CalendarModelInterface } from "@/components/_global/Calendar.vue";

/**
 * API
 */
import compositionsAPI from "@/api/compositions";
import { Guid } from "@/domain/guid";
import { GetCompositionGroupsResponse } from "@/api/compositions/get-composition-groups.response";
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";
import { SignupState } from "@/api/compositions/signup-state";


/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Calendar page.
 */
@Component({
	components: {
		CreateCompositionGroupDialog,
		CalendarDayList,
		Calendar
	}
})
export default class CalendarPage extends Vue {
	$refs!: {
		calendarRef: Calendar;
		createCompositionGroupDialog: CreateCompositionGroupDialog;
	};

	/// Injections

	/// Attributes
	isLoading = false;
	isEditMode = false;
	compositionGroups: GetCompositionGroupsResponse.CompositionGroup[] | null = null;

	showContextMenu = false;
	contextMenuX = 0;
	contextMenuY = 0;
	tempContextMenuID: Guid | null = null;
	tempContextMenuDate: string | null = null;
	contextMenuCopiedID: Guid | null = null;

	calendar: CalendarModelInterface | null = null;

	/**
	 * Get the title of the calendar.
	 * ex. "January 2020"
	 */
	get title() {
		if (!this.calendar) {
			return null;
		}
		const startMonth = getMonthName(this.calendar.month);
		const startYear = this.calendar.year;

		return `${startMonth} ${startYear}`;
	}

	get canManageCompositions() {
		return this.hasPermission(roles.MANAGE_COMPOSITIONS);
	}

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;


	/// Methods
	async created() {
	}

	prev() {
		this.$refs.calendarRef?.prev();
	}

	next() {
		this.$refs.calendarRef?.next();
	}

	async fetchCompositions(forceLoading = true) {
		this.isLoading = true;
		try {
			if (this.calendar) {
				if (forceLoading) {
					this.compositionGroups = null;
				}
				this.compositionGroups = await compositionsAPI.fetchCompositions(this.currentTeam.id, this.calendar.month, this.calendar.year);
			}
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	@Watch("calendar", {deep: true})
	async onCalendarChanged(val: CalendarModelInterface, oldVal: CalendarModelInterface | null) {
		if (oldVal == null || (val.year !== oldVal.year || val.month !== oldVal.month)) {
			await this.fetchCompositions(true);
		}
	}

	async handleCreateCompositionGroupClick(date: string) {
		await this.$refs.createCompositionGroupDialog.open(date);
	}

	async handleAfterCreateCompositionGroup(id: Guid) {
		await this.fetchCompositions(false);
		//await this.$router.push(teamUrl(this.currentTeam, `/events/${id}/compositions/edit`));
	}

	handleChipContextMenu(id: Guid, ev: PointerEvent) {
		this.tempContextMenuID = id;
		this.triggerShowContextMenu(ev);
		return false;
	}

	handleDayContextMenu(date: string, ev: PointerEvent) {
		if (!this.showContextMenu) {
			this.tempContextMenuID = null;
			this.tempContextMenuDate = null;
		}
		this.tempContextMenuDate = date;
		this.triggerShowContextMenu(ev);
		return false;
	}

	triggerShowContextMenu(ev: PointerEvent) {
		if (!this.canManageCompositions) {
			return;
		}
		this.showContextMenu = false;

		this.$nextTick(() => {
			this.contextMenuX = ev.clientX;
			this.contextMenuY = ev.clientY;
			this.showContextMenu = true;
		});
	}

	handleCopyComposition() {
		this.contextMenuCopiedID = this.tempContextMenuID;
		this.$snackbar.openInfo(this.$t("calendar.copy_success"));
	}

	async handlePasteComposition() {
		try {
			if (this.tempContextMenuDate && this.contextMenuCopiedID) {
				await compositionsAPI.copyComposition(this.contextMenuCopiedID, this.tempContextMenuDate);
			}
		} catch (error) {
			this.handleAPIError(error);
		}

		await this.fetchCompositions(false);
	}

	async handleSignup(compositionGroupID: Guid, newSignupState: SignupState) {
		await compositionsAPI.setSignupState(compositionGroupID, {
			signupState: newSignupState,
			characterID: null,
			comment: null,
			role: null,
		});
		await this.fetchCompositions(false);
	}

	async handleToggleEditMode() {
		this.isEditMode = !this.isEditMode;
		await this.fetchCompositions(false);
	}
}
